/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.FORM.ACTIONS,
    buttons: [
      {
        label: "Previous",
        size: "large",
        appearance: "secondary",
        prefix: "chevronLeft",
        action: "form:previous",
        skippable: true
      },
      {
        label: "Next",
        size: "large",
        appearance: "primary",
        suffix: "chevronRight",
        action: "form:next"
      }
    ]
  },
  {
    fieldType: FIELD.TEXT.PAGEHEADING,
    label: "Need support?",
    description: "See the [User Guide](/assets/Self Assessment and Quality Improvement Planning Portal User Guide.pdf) for detailed steps and guidance on accessing the Self-Assessment and Quality Improvement Planning Portal."
  }
];